const TRIAL_PRODUCT_IDS: Record<string, number> = {
  dev: 43,
  staging: 43,
  production: 33,
}

/**
 * Get China Android free trial product id by build mode.
 * Returns undefined when not configured for the provided mode.
 */
export function getChinaAndroidTrialProductId(mode: string) {
  return TRIAL_PRODUCT_IDS[mode]
}
